import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  workspaceCreateErrorTitle: {
    id: 'frontbucket.workspace.createWorkspaceError.title',
    description: 'Text for the title of the create workspace error',
    defaultMessage: `We couldn't create a workspace`,
  },
  workspaceCreateErrorDescription: {
    id: 'frontbucket.workspace.createWorkspaceError.description',
    description:
      'Text for the description of the create workspace error. The "check our status page" link text is wrapped in <link> tags.',
    defaultMessage:
      'If this keeps happening, <link>check our status page</link>.',
  },
});
